export enum PropertyPortalStates {
  DEACTIVATED = 'DEACTIVATED',
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  ERROR = 'ERROR',
  RENTED = 'RENTED', // TODO: clean up… this is in fact not a portal state and duplicates PropertyStatuses.RENTED
  RESERVED = 'RESERVED' // TODO: clean up… this is in fact not a portal state and duplicates PropertyStatuses.RESERVED
}
